<template>
  <div class="cart-products seccion-gris">
    <section>
      <CartBreadcumbs :stepActive="3" />
      <div class="container">
        <div v-if="visaFinalization" class="row">
          <NiubizProcess :transactionToken="transactionToken" />
        </div>
        <div v-else class="row">
          <CartCalculatorWebPayment :configData="configData" />
        </div>
      </div>
    </section>
    <GoToTrackingModule />
    <GuideModule />
  </div>
</template>

<script>
import GoToTrackingModule from '@/modules/GoToTrackingModule.vue';
import GuideModule from '@/modules/GuideModule.vue';
import { config_settings } from '@/config.js';
import CartBreadcumbs from '@/components/products/cart/components/CartBreadcumbs.vue';
import CartCalculatorWebPayment from '@/components/products/cart/CartProductsStepThree/components/CartCalculatorWebPayment.vue';
import NiubizProcess from '@/components/products/cart/CartProductsStepThree/components/NiubizProcess.vue';
import { mapState, mapActions, mapMutations } from 'vuex';
import '@/components/products/cart/CartStyles.scss';

export default {
  name: 'CartProductsStepThree',
  components: {
    CartCalculatorWebPayment,
    NiubizProcess,
    CartBreadcumbs,
    GoToTrackingModule,
    GuideModule,
  },
  props: ['visaFinalization', 'configData'],
  data() {
    return {
      imgPreUrl: config_settings.PHOTO_SERVER_URL + '/',
      transactionToken: this.$route.params.token,
    };
  },
  computed: mapState(['cartProducts']),
  methods: {
    /* Resetting the store and localstorage after removing product from cart */
    ...mapMutations(['SET_CART_PRODUCTS']),

    removeProductCart(product) {
      var products = JSON.parse(localStorage.getItem('iki-cart'));
      for (let i = 0; i < products.length; i++) {
        if (products[i].code_product === product.code_product) {
          products.splice(i, 1);
        }
      }
      this.SET_CART_PRODUCTS(products);
      localStorage.setItem('iki-cart', JSON.stringify(products));
      this.$refs.cartCalculator.analizeCart();
    },

    navigateProductDetail(product) {
      this.$router.push({
        name: 'detalle-productos',
        params: { id: product.code_product },
      });
    },

    scrollToTop() {
      window.scrollTo(0, 0);
    },
  },

  created() {
    this.scrollToTop();
  },
};
</script>
